import React from 'react';
import './BookingsManagement.css';

/**
 * ContactInfo Component - Displays contact information for a booking
 * @param {Object} props - Component props
 * @param {Object} props.booking - The booking object containing contact information
 * @returns {JSX.Element} - Rendered component
 */
function ContactInfo({ booking }) {
  // Determine if this is a guest booking or a registered user booking
  const isGuestBooking = booking.guest_profile_id && !booking.user_id;
  
  return (
    <>
      <div className="contact-preview">
        <span className="contact-icon">📧</span>
        <span className="contact-label">
          {isGuestBooking ? 'Guest Contact' : 'Contact Info'}
        </span>
      </div>
      <div className="contact-details">
        <div className="contact-item">
          <span className="contact-type">Email:</span>
          <span className="contact-value">
            {isGuestBooking 
              ? booking.guest_profiles?.email 
              : booking.profiles?.email}
          </span>
        </div>
        <div className="contact-item">
          <span className="contact-type">Phone:</span>
          <span className="contact-value">
            {isGuestBooking 
              ? booking.guest_profiles?.phone_number 
              : booking.profiles?.phone_number}
          </span>
        </div>
        {isGuestBooking && (
          <div className="contact-item contact-item--guest">
            <span className="contact-badge">Guest Booking</span>
          </div>
        )}
      </div>
    </>
  );
}

export default ContactInfo; 